/* eslint-disable */
// @ts-nocheck

import { CheckCircleIcon } from 'lucide-react'

import { RectangleGroupIcon } from '@heroicons/react/24/outline'

import {
  categoriesToOptions,
  useCategoriesQuery,
} from '../hooks/useCategoriesQuery'
import { containerStatusOptions } from './constants/statusOptions'
import { AdvancedFilters } from './filter/AdvancedFilters'
import { SearchQuery } from './filter/SearchQuery'
import { SelectFilter } from './filter/SelectFilter'
import { useContainerFilters } from './hooks/useContainerFilters'
import { returnedOptions } from './options/returnedOptions'
import { SelectionSummary } from './SelectionSummary'

export const FiltersRow = () => {
  // Use the nuqs-based filter hook
  const {
    filters,
    updateSearch,
    updateStatus,
    updateCategory,
    updateIsReturned,
    updateOwnerCompanyId,
    updateLogisticCompanyId,
    updateTransporterCompanyId,
    updateStorageCompanyId,
    clearAllFilters,
    hasActiveFilters,
  } = useContainerFilters()

  // Fetch categories for filter
  const { data: categoriesData } = useCategoriesQuery()
  const categoryOptions = categoriesToOptions(categoriesData?.items || [])

  const handleClearFilters = () => {
    // Clear nuqs filters
    clearAllFilters()
  }

  // Check if any filters are active - now only using nuqs filters
  const hasAnyActiveFilters = hasActiveFilters

  return (
    <div className="mb-2">
      <div className="flex flex-col gap-4">
        <div className="flex flex-wrap items-center gap-2">
          <SearchQuery
            onSearchChange={updateSearch}
            placeholder="Buscar por número de operación o nombre..."
            searchQuery={filters.search}
          />

          <SelectFilter
            activeSelections={filters.status}
            icon={<RectangleGroupIcon className="h-4 w-4" />}
            onSelectionsChange={updateStatus}
            placeholder="Buscar estado..."
            searchActive={false}
            selectionOptions={containerStatusOptions}
            title="Estado"
          />

          <SelectFilter
            activeSelections={[filters.isReturned]}
            icon={<CheckCircleIcon className="h-4 w-4" />}
            onSelectionsChange={(values) => updateIsReturned(values[0])}
            placeholder="Buscar retornado..."
            searchActive={false}
            selectionOptions={returnedOptions}
            title="Retornado"
          />

          <AdvancedFilters
            category={filters.category}
            categoryOptions={categoryOptions}
            logisticCompanyId={filters.logisticCompanyId}
            ownerCompanyId={filters.ownerCompanyId}
            storageCompanyId={filters.storageCompanyId}
            transporterCompanyId={filters.transporterCompanyId}
            updateCategory={updateCategory}
            updateLogisticCompanyId={updateLogisticCompanyId}
            updateOwnerCompanyId={updateOwnerCompanyId}
            updateStorageCompanyId={updateStorageCompanyId}
            updateTransporterCompanyId={updateTransporterCompanyId}
          />
        </div>

        {hasAnyActiveFilters && (
          <SelectionSummary
            // Active nuqs filters
            activeIsReturned={filters.isReturned}
            activeStatuses={filters.status}
            categoryOptions={categoryOptions}
            logisticCompanyId={filters.logisticCompanyId}
            searchQuery={filters.search}
            setActiveCategories={updateCategory}
            setActiveIsReturned={updateIsReturned}
            setActiveStatuses={updateStatus}
            setSearchQuery={updateSearch}
            statusOptions={containerStatusOptions}
            storageCompanyId={filters.storageCompanyId}
            transporterCompanyId={filters.transporterCompanyId}
            updateLogisticCompanyId={updateLogisticCompanyId}
            updateOwnerCompanyId={updateOwnerCompanyId}
            updateStorageCompanyId={updateStorageCompanyId}
            updateTransporterCompanyId={updateTransporterCompanyId}
            handleClearFilters={handleClearFilters}
            // New filters
            activeCategories={filters.category}
            returnedOptions={returnedOptions}
            // Company filters
            ownerCompanyId={filters.ownerCompanyId}
          />
        )}
      </div>
    </div>
  )
}
